import React from 'react'
import propTypes from 'prop-types'

//MUI
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'

const buttonStyles = makeStyles({
    root: props => ({
        margin: props.topMargin ? '12px' : '5px',
        minWidth: '100px',
        width: props.width && props.width,
        background: props.backgroundColor,
        color: 'white',
        '&:hover': {
            background: 'white',
            color:  props.backgroundColor,
        },
    })
})

const TaButton = React.memo(({ id, label, disabled, onClick, size, variant, topMargin, index, hidden, width, backgroundColor, type }) => {
    const buttonClasses = buttonStyles({ topMargin, width, backgroundColor })

    return (
        !hidden && <Button
            id={id}
            variant={variant}
            // color="primary"
            disabled={disabled}
            onClick={onClick}
            size={size}
            classes={buttonClasses}
            data-id={index}
            type={type}>
            {label}
        </Button>
    )
})

TaButton.propTypes = {
    id: propTypes.string.isRequired,
    label: propTypes.string.isRequired,
    disabled: propTypes.bool.isRequired,
    onClick: propTypes.func.isRequired,
    variant: propTypes.string,
    size: propTypes.string,
    loading: propTypes.bool,
    topMargin: propTypes.bool,
    setRef: propTypes.func,
    hidden: propTypes.bool,
    width: propTypes.string,
    backgroundColor: propTypes.string,
    type: propTypes.string,
}

TaButton.defaultProps = {
    disabled: false,
    variant: "contained",
    size: "medium",
    topMargin: true,
    hidden: false,
    backgroundColor: "var(--main-bg-color2)",
    type: "button"
}

export default TaButton